import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Typography,
  Paper,
  FormGroup,
  FormControlLabel,
  Switch,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useThemeContext } from "../../config/ThemeProvider";
import { useUserPreferences } from "../../hooks/useUserPreferences";
import Cookies from "js-cookie";

const SettingsPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { paletteType, togglePalette } = useThemeContext();
  const { updatePaletteType } = useUserPreferences();
  const isAuthenticated = !!Cookies.get("token");

  const handleThemeToggle = () => {
    // Toggle la palette dans le contexte local immédiatement
    togglePalette();

    // Sauvegarder la nouvelle palette dans les préférences utilisateur si l'utilisateur est connecté
    if (isAuthenticated) {
      const newPaletteType = paletteType === "warm" ? "dark" : "light";
      updatePaletteType(newPaletteType);
    }
  };

  const handleLanguageChange = (event: any) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <Box sx={{ p: 3, maxWidth: 800, mx: "auto" }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
        {t("settings.title")}
      </Typography>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
          {t("settings.appearance.title")}
        </Typography>

        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={paletteType === "dark"}
                onChange={handleThemeToggle}
                color="primary"
              />
            }
            label={t("settings.appearance.darkMode")}
          />
        </FormGroup>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {t("settings.appearance.darkModeDescription")}
        </Typography>
      </Paper>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
          {t("settings.language.title")}
        </Typography>

        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="language-select-label">
            {t("settings.language.selectLabel")}
          </InputLabel>
          <Select
            labelId="language-select-label"
            id="language-select"
            value={i18n.language}
            label={t("settings.language.selectLabel")}
            onChange={handleLanguageChange}
          >
            <MenuItem value="en">English</MenuItem>
            <MenuItem value="fr">Français</MenuItem>
          </Select>
        </FormControl>

        <Typography variant="body2" color="text.secondary">
          {t("settings.language.description")}
        </Typography>
      </Paper>
    </Box>
  );
};

export default SettingsPage;
